import React, { Component } from 'react';
import { MsalProvider, withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import BreadCrumbComponent from '../../bread-crumb/BreadCrumbComponent';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../../AppInsights';
import { IACLService } from '../IACLService';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import Spinner from "../../Spinner";
import AlertMessage from "../../alertmessage/AlertMessage"
import { MessageSeverity, FilterMatchMode, FilterOperator } from 'primereact/api';
import * as Yup from 'yup';

//HDO-5469 - PI 2024 Q3 - Integrate IACL UI features into the Monitoring tool
class MessageTypeComponent extends Component {
    constructor() {
        super();
        this.WrappedMessageTypeComponent = React.createRef();
        this._isMounted = false;
        this.state = {
            pageErrorMessage: '',
            pageSuccessMessage: '',
            messageTypeList: [],
            messageType: {
                Id: 0,
                MessageType: null,
                IsActive: false
            },
            MessageTypeAuditLogs: [],
            hideSpinner: false,
            showpagination: false,
            editMsgTypeDialogBoxVisible: false,
            createMsgTypeDialogBoxVisible: false,
            confirmDeleteMsgTypeDialogBoxVisible: false,
            msgTypeAuditLogDialogBoxVisible: false,
            confirmDeleteVisible: false,
            dt: React.createRef(),
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',
        }
        this.IACLService = new IACLService();
    }

    componentDidMount() {
        this._isMounted = true;
        this.getAllMessageType();
    }

    getAllMessageType = () => {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getAllMessageType(false, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        this.setState({ messageTypeList: d.body, hideSpinner: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.messageTypeList.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getMsgTypeOpsAuditLog = (rowData) => {
        this.setState({ messageType: { ...rowData }, hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' });
        this.IACLService.getMsgTypeOpsAuditLog(rowData.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted) {
                        this.setState({ MessageTypeAuditLogs: d.body, hideSpinner: true, msgTypeAuditLogDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' });
                        if (this.state.MessageTypeAuditLogs.length > 10) {
                            this.setState({ showpagination: true })
                        }
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    editMessageType = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-book" className="p-button-rounded p-button-outlined" tooltip="Logs" tooltipOptions={{ position: 'top' }} onClick={(e) => this.getMsgTypeOpsAuditLog(rowData)} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-primary p-mr-2" tooltip="Edit" tooltipOptions={{ position: 'top' }} onClick={() => this.showEditMsgTypeDialog(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" tooltip="Delete" tooltipOptions={{ position: 'top' }} onClick={e => this.setState({ confirmDeleteMsgTypeDialogBoxVisible: true, pageErrorMessage: null, pageSuccessMessage: null, messageType: { ...rowData } })} />
            </React.Fragment>
        );
    }

    showEditMsgTypeDialog = (rowData) => {
        this.setState({ messageType: { ...rowData }, editMsgTypeDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
    }

    showMsgTypeDialogBoxForCreate = () => {
        this.clearRowSelection();
        this.setState({ createMsgTypeDialogBoxVisible: true, pageSuccessMessage: '', pageErrorMessage: '' })
    }

    clearRowSelection() {
        this.setState({
            messageType: {
                Id: 0,
                MessageType: null,
                IsActive: null
            },
        })
    }

    handleInputChange = (event) => {
        this.setState({
            messageType: {
                ...this.state.messageType, //using spread operator to initialize object with existing props
                [event.target.name]: event.target.value
            },
            pageErrorMessage: null
        });
    }

    validateEditMsgTypeDialogFormField = async (messageType, onSave = false, isCreate = false) => {

        console.log(messageType)

        if (onSave || isCreate) {
            try {
                let msgContentSchema = Yup.object({
                    MessageType: Yup.string().required("Message type is required.")
                        .max(50, "Message type cannot be more than 50 characters.")
                        .matches(/^[^'"]*$/, "Message type should not contain single (') or double (\") quotes.")
                });
                await msgContentSchema.validate(messageType, { abortEarly: false })

                this.setState({ pageErrorMessage: '' });
                this.IsMessageTypeExists(isCreate);
            }
            catch (error) {
                this.setState({ pageErrorMessage: error.inner[0].message });
            }
        }
    }

    IsMessageTypeExists(isCreate = false) {
        this.setState({ hideSpinner: false, pageSuccessMessage: '', pageErrorMessage: '' })
        this.IACLService.IsMessageTypeExists(this.state.messageType.MessageType, this.state.messageType.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (d.status === 200 && d.body) {
                        this.setState({ pageErrorMessage: 'The message type provided already exists. Please use a different one.', hideSpinner: true });
                    }
                    else {
                        if (isCreate)
                            this.createMessageType();
                        else
                            this.updateMessageType();
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    createMessageType() {
        let body = JSON.stringify(this.state.messageType);
        this.IACLService.createMessageType(body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllMessageType();
                        this.setState({ pageSuccessMessage: 'Message type created successfully', createMsgTypeDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    updateMessageType() {
        let body = JSON.stringify(this.state.messageType);
        this.IACLService.updateMessageType(this.state.messageType.Id, body, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.' });
                } else {
                    if (this._isMounted && d.status === 200) {
                        this.getAllMessageType();
                        this.setState({ pageSuccessMessage: 'Changes saved successfully.', editMsgTypeDialogBoxVisible: false, hideSpinner: true });
                    }
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    saveFooter = (
        <div>
            <Button label='Save' onClick={() => this.validateEditMsgTypeDialogFormField(this.state.messageType, true)} />
            <Button label='Cancel' onClick={e => this.setState({ editMsgTypeDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    createFooter = (
        <div>
            <Button label='Create' onClick={() => this.validateEditMsgTypeDialogFormField(this.state.messageType, true, true)} />
            <Button label='Cancel' onClick={e => this.setState({ createMsgTypeDialogBoxVisible: false, pageErrorMessage: null })} className='p-button-secondary' />
        </div>
    );

    deleteMessageType() {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null, hideSpinner: false })
        this.IACLService.deleteMessageType(this.state.messageType.Id, this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to perform this operation.', confirmDeleteMsgTypeDialogBoxVisible: false, hideSpinner: true });
                } else if (d.status === 200 && d.body) {
                    this.setState({ pageSuccessMessage: 'Message type deleted successfully.', confirmDeleteMsgTypeDialogBoxVisible: false, hideSpinner: true });
                    this.getAllMessageType();
                } else if (d.status === 500 && d.body) {
                    this.setState({ pageErrorMessage: d.body.error, confirmDeleteMsgTypeDialogBoxVisible: false, hideSpinner: true });
                } else {
                    this.setState({ pageErrorMessage: 'Something went wrong', confirmDeleteMsgTypeDialogBoxVisible: false, hideSpinner: true });
                }
            }
        ).catch(e => {
            console.log(e)
        });
    }

    confirmDeleteFooter = (
        <div>
            <Button label='Ok' onClick={() => this.deleteMessageType()} />
            <Button label='Cancel' onClick={e => this.setState({ confirmDeleteMsgTypeDialogBoxVisible: false })}
                className='p-button-secondary' />
        </div>
    );

    onGlobalFilterChange = (event, filtersKey) => {
        this.setState({ pageErrorMessage: null, pageSuccessMessage: null })

        const value = event.target.value;
        let filters = { ...this.state[filtersKey] };
        filters['global'].value = value;

        this.setState({ [`${filtersKey}`]: filters });
    }

    globalSearchFilter = (filtersKey) => {
        return (

            <div>
                <div className="flex justify-content-between" >
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearDataTableFilters} />
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"></i>
                        <InputText type="search" value={this.state[`${filtersKey}`]['global'].value || ''} onChange={(e) => this.onGlobalFilterChange(e, filtersKey)} placeholder="Global Search" size="100" />
                    </span>
                    <span>
                        <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={this.getAllMessageType} icon="pi pi-refresh" />
                    </span>
                </div>
            </div>
        )
    }

    clearDataTableFilters = () => {
        this.setState({
            pageErrorMessage: null,
            pageSuccessMessage: null,
            pageErrorMessage: null,
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            globalFilterValue: '',

        })
        sessionStorage.clear();
    }

    booleanChecker = (rowData) => {
        if (rowData.IsActive) {
            return <span className='masterdata-status-badge status-active'>ACTIVE</span>;
        }
        else {
            return <span className='masterdata-status-badge status-inactive'>INACTIVE</span>;
        }
    };

    onStatusSwitchChange = (e) => {
        this.setState({ messageType: { ...this.state.messageType, IsActive: e.value }, pageErrorMessage: null, pageSuccessMessage: null })
    }

    showAlertMessage = (severity, alertMsg) => {
        this.alertMsg.showAlert(severity, alertMsg);
    }

    render() {
        return (
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <div className="messageTypeContainer">
                    <BreadCrumbComponent {...this.props} />

                    <AlertMessage ref={instance => { this.alertMsg = instance }} />
                    {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                    {this.state.pageSuccessMessage ? this.showAlertMessage(MessageSeverity.SUCCESS, this.state.pageSuccessMessage) : <></>}

                    <div hidden={this.state.hideSpinner}>
                        <Spinner />
                    </div>

                    <div>
                        <div className='flex justify-content-between' style={{ marginBottom: '10px' }}>
                            <div className="page-header-title">MESSAGE TYPES</div>
                            <Button label='' icon='pi pi-plus' tooltip='Create Message Type' tooltipOptions={{ position: 'left' }} onClick={this.showMsgTypeDialogBoxForCreate} />
                        </div>

                        <DataTable ref={(el) => this.dt = el} value={this.state.messageTypeList}
                            selectionMode="single"
                            filters={this.state.filters}
                            filterDisplay="menu"
                            responsiveLayout="scroll"
                            header={this.globalSearchFilter('filters')}
                            paginator={this.state.showpagination}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            emptyMessage="No Records found."
                            showGridlines={true}
                            onFilter={(e) => this.setState({ filters: e.filters })}
                            stateStorage="session" stateKey="dt-messageType-session"
                        >
                            <Column field="MessageType" header="Message Type" style={{ textAlign: 'left' }} />
                            <Column field="Status" header="Status" style={{ textAlign: 'left' }} body={this.booleanChecker} />
                            <Column field="edit" header="Action" body={this.editMessageType} style={{ whiteSpace: 'nowrap', width: '150px', textAlign: 'center' }} alignHeader='center' />
                        </DataTable>
                    </div>

                    <Dialog header='Edit Message Type' footer={this.saveFooter}
                        visible={this.state.editMsgTypeDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ editMsgTypeDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '400px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.messageType.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.messageType.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Message Type</b></label>
                                        <InputText type='text' name='MessageType' value={this.state.messageType.MessageType || ''}
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Create Message Type' footer={this.createFooter}
                        visible={this.state.createMsgTypeDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ createMsgTypeDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false}>
                        <div>
                            {this.state.pageErrorMessage ? this.showAlertMessage(MessageSeverity.ERROR, this.state.pageErrorMessage) : <></>}
                            <table style={{ width: '400px' }}>
                                <tr>
                                    <td>
                                        <label><b>Enable</b></label>
                                        <InputSwitch checked={this.state.messageType.IsActive} onChange={this.onStatusSwitchChange}
                                            tooltip={this.state.messageType.IsActive ? 'YES' : 'NO'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label className='required-field'><b>Message Type</b></label>
                                        <InputText type='text' name='MessageType' value={this.state.messageType.MessageType || ''} required
                                            onChange={this.handleInputChange} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Dialog>

                    <Dialog header='Delete Message Type' footer={this.confirmDeleteFooter}
                        visible={this.state.confirmDeleteMsgTypeDialogBoxVisible} width='400px' modal={true}
                        onHide={e => this.setState({ confirmDeleteMsgTypeDialogBoxVisible: false })} maximizable={false}>
                        <div>
                            Are you sure you want to delete the message type <b>{this.state.messageType.MessageType}</b>?
                        </div>
                    </Dialog>

                    <Dialog header={this.state.messageType.MessageType + ' - Audit Logs'} style={{ width: '40vw' }}
                        visible={this.state.msgTypeAuditLogDialogBoxVisible} modal={true}
                        onHide={e => this.setState({ msgTypeAuditLogDialogBoxVisible: false, pageErrorMessage: null })} maximizable={false} closeOnEscape={true}>
                        <div>
                            <DataTable value={this.state.MessageTypeAuditLogs}
                                selectionMode="single"
                                paginator={true}
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50, 100]}
                                filterDisplay="menu"
                                responsiveLayout="scroll"
                                showGridlines removableSort
                                emptyMessage="No Records found."
                                sortField='Timestamp' sortOrder="-1"
                            >
                                <Column field="DisplayTimestamp" header="Timestamp" style={{ textAlign: 'left' }} sortable sortField='Timestamp' />
                                <Column field="ActionType" header="Action" style={{ textAlign: 'left' }} />
                                <Column field="ActionBy" header="Action By" style={{ textAlign: 'left' }} />
                            </DataTable>
                        </div>
                    </Dialog>

                </div>
            </MsalAuthenticationTemplate>
        )
    }
}

const WrappedMessageTypeComponent = withMsal(MessageTypeComponent);
export default withAITracking(reactPlugin, WrappedMessageTypeComponent);